import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {InternalColumn, InternalImpactPointService, InternalSection} from '@shared/components/internal-impact-point/internal-impact-point.service';
import {VehicleNature} from '../../../../claims/claims-commons/models/vehicle.model';

@Component({
    selector: 'amd-internal-impact-point-section',
    templateUrl: './internal-impact-point-section.component.html',
    styleUrls: ['./internal-impact-point-section.component.scss']
})
export class InternalImpactPointSectionComponent implements OnChanges {

    @Input() section: InternalSection;

    columns: InternalColumn[] = [];

    get nature(): VehicleNature {
        return this.internalImpactPointService.nature;
    }

    constructor(private internalImpactPointService: InternalImpactPointService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.section && changes.section.previousValue !== changes.section.currentValue) {
            this.columns = this.internalImpactPointService.getColumns(this.nature, this.section);
        }
    }

}

